<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="vehicle-team-main">
    <div>
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="table-box-container">
      <TableBox
        title="Vehicle Team"
        :tableData="vehicleTeamListMaster"
        :maxSelection="1"
        :selectedRow.sync="vehicleTeamTableBoxSelectedRow"
        :loading="vehicleTeamTableBoxLoading"
      />
    </div>

    <PopupEntry
      class="popup-entry-component"
      :show.sync="showPopupEntry"
      v-if="showPopupEntry"
      :title="popupEntryTitle"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
      @save="popupEntrySaveClicked"
      :requiredError="popupEntryRequiredError"
      :successMessages="popupEntrySuccessMessages"
      :messages="popupEntryMessages"
      :errorMessages="popupEntryErrorMessages"
      @requiredClicked="popupEntryRequiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div class="general-details">
        <!-- vehicle team code -->
        <div class="team-code">
          <Input
            class="team-code-input"
            placeholder="Team Code"
            :inputValue.sync="teamCodeInputValue"
            :isRequired="true"
            :isDisabled="viewModePK"
            :errorMessage.sync="teamCodeErr"
            ref="teamCodeErr"
            validator="masterfilecode,10,uppercase"
          />
        </div>
        <div>
          <Input
            placeholder="Team Description"
            :inputValue.sync="teamDescription"
            :isRequired="true"
            :isDisabled="viewMode"
            validator="text,50"
            :errorMessage.sync="teamDescriptionErr"
            ref="teamDescriptionErr"
          />
        </div>
        <div>
          <InputQuery
            placeholder="Team Group"
            :isRequired="false"
            :isDisabled="viewMode"
            validator="text,10,uppercase"
            :items="teamGroupListMaster"
            :allowFreeText="false"
            :errorMessage.sync="teamGroupErr"
            :selectedObject.sync="selectedTeamGroup"
            ref="teamGroupErr"
            itemKey="Team"
            descKey="TeamGroupDesc"
          />
        </div>
        <div>
          <InputQuery
            placeholder="System"
            :isDisabled="isSystemDisabled"
            :items="systemListMaster"
            :allowFreeText="false"
            :errorMessage.sync="systemErr"
            :selectedObject.sync="selectedSystem"
            @update:selectedObject="handleSystemSelection"
            validator="text,100,uppercase"
            ref="systemErr"
            :isRequired="true"
            itemKey="combinedSystemName"
            descKey="Application Name"
          />
        </div>
      </div>
      <!-- team management section -->
      <div class="team-management-section">
        <div class="vehicle-list" v-if="isHmsOrTms">
          <div class="call-to-action-buttons">
            <button
              :disabled="!isHmsOrTms || viewMode || vehicleWithTeamTableBoxSelectedRow.length === 0"
              @click="removeVehiclesClicked"
              style="margin-left: 5px"
              >Remove</button
            >
          </div>
          <div class="table-box-container">
            <TableBox
              title="Vehicle List"
              :tableData="vehicleWithTeam"
              :maxSelection="-1"
              :selectedRow.sync="vehicleWithTeamTableBoxSelectedRow"
              :loading="vehicleWithTeamTableBoxLoading"
            />
          </div>
        </div>

        <div class="vehicles-list" v-if="isHmsOrTms && !viewMode">
          <div class="call-to-action-buttons">
            <button
              style="margin-right: 5px"
              :disabled="!isHmsOrTms || viewMode || vehicleWithoutTeamTableBoxSelectedRow.length === 0"
              @click="addNewTeamInputClicked"
              >Add</button
            >
          </div>
          <div class="table-box-container">
            <TableBox
              title="Vehicle List"
              :tableData="vehicleWithoutTeam"
              :maxSelection="-1"
              :selectedRow.sync="vehicleWithoutTeamTableBoxSelectedRow"
              :loading="vehicleWithoutTeamTableBoxLoading"
            />
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    isHmsOrTms() {
      const systemCode = this.selectedSystem?.['System']?.toUpperCase();
      return systemCode === 'HMS' || systemCode === 'TMS';
    },
    isSystemDisabled() {
      return this.viewMode || (this.viewModePK && this.isHmsOrTms);
    },
  },
  data: function () {
    return {
      vehicleTeamListMaster: [],
      systemListMaster: [],
      vehicleTeamTableBoxLoading: false,
      vehicleTeamTableBoxSelectedRow: [],
      vehicleWithoutTeam: [],
      vehicleWithTeam: [],
      vehicleWithoutTeamTableBoxLoading: false,
      vehicleWithoutTeamTableBoxSelectedRow: [],
      vehicleWithTeamTableBoxLoading: false,
      vehicleWithTeamTableBoxSelectedRow: [],
      menu: [
        {
          title: 'New Vehicle Team',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Vehicle Team',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
        {
          title: 'Delete Vehicle Team',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: false,
        },
        {
          title: 'View Vehicle Team',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },
      ],

      // popup entry state
      showPopupEntry: false,
      popupEntryTitle: '',
      updatedBy: '',
      createdBy: '',
      viewMode: false,
      viewModePK: false,
      popupEntryRequiredError: [],
      popupEntrySuccessMessages: [],
      popupEntryMessages: [],
      popupEntryErrorMessages: [],

      // popup entry common fieLd
      teamCodeInputValue: '',
      teamCodeErr: '',
      teamDescription: '',
      teamDescriptionErr: '',
      teamGroupErr: '',
      systemErr: '',
      selectedSystem: null,
      previousSystem: null,
      isUserSelection: false,
      teamGroupListMaster: [],
      selectedTeamGroup: null,
    };
  },
  props: {},
  methods: {
    //retrieve data to display in table
    getVehicleTeamListMaster: async function () {
      this.vehicleTeamTableBoxLoading = true;
      this.vehicleTeamListMaster = [];
      this.vehicleTeamTableBoxSelectedRow = [];
      this.vehicleTeamListMaster = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TEAM' });
      this.vehicleTeamTableBoxLoading = false;
    },

    getVehicleWithOutTeamListMaster: async function (excludeTeam = null) {
      this.vehicleWithoutTeamTableBoxLoading = true;
      this.vehicleWithoutTeam = [];
      this.vehicleWithoutTeamTableBoxSelectedRow = [];
      const allVehicles = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'VEHICLETEAMMANAGEMENT_DISPLAY',
      });
      if (excludeTeam && this.vehicleWithTeam.length > 0) {
        const teamVehicleCodes = new Set(
          this.vehicleWithTeam.map((v) => v['Vehicle Code'] || v.VehicleCode || v.vehiclecode),
        );
        this.vehicleWithoutTeam = allVehicles.filter(
          (vehicle) => !teamVehicleCodes.has(vehicle['Vehicle Code'] || vehicle.VehicleCode || vehicle.vehiclecode),
        );
      } else {
        this.vehicleWithoutTeam = allVehicles;
      }

      this.vehicleWithoutTeamTableBoxLoading = false;
    },

    getVehicleWithTeamListMaster: async function (Team) {
      this.vehicleWithTeamTableBoxLoading = true;
      this.vehicleWithTeam = [];
      this.vehicleWithTeamTableBoxSelectedRow = [];
      this.vehicleWithTeam = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'VEHICLETEAMMANAGEMENT_SELF',
        team: Team,
      });
      this.vehicleWithTeamTableBoxLoading = false;
    },

    getTeamGroupListMaster: async function () {
      const response = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TEAM' });
      this.teamGroupListMaster = response.map((item) => ({
        ...item,
        Team: item['Team'],
        TeamGroupDesc: item['Team'],
      }));
    },

    getVehicleTeamDetails: async function (vehicleTeam) {
      const results = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'VEHICLETEAM',
        recordid: vehicleTeam,
      });
      return results['Team'];
    },
    menuClicked: async function (e) {
      this.clearPopupEntryMessages();
      this.resetPopupEntryFields();

      switch (e.title) {
        case 'New Vehicle Team':
          this.popupEntryTitle = 'New Vehicle Team';
          this.viewMode = false;
          this.viewModePK = false;
          this.showPopupEntry = true;
          await this.getVehicleWithOutTeamListMaster();
          break;

        case 'Edit Vehicle Team': {
          const selectedTeamCode = this.vehicleTeamTableBoxSelectedRow[0]?.Team;
          if (!selectedTeamCode) {
            this.$showAlert('error', 'No Vehicle Team is selected', 'Please select a Vehicle Team to view');
            return;
          }

          this.$fullscreenLoading('Getting Vehicle Team Details');
          this.populatePopupEntryFields(
            await this.getVehicleTeamDetails(this.vehicleTeamTableBoxSelectedRow[0]['Team']),
          );
          await this.getVehicleWithTeamListMaster(selectedTeamCode);
          await this.getVehicleWithOutTeamListMaster(selectedTeamCode);
          this.$fullscreenLoading();

          this.viewMode = false;
          this.viewModePK = true;
          this.showPopupEntry = true;
          this.popupEntryTitle = 'Edit Vehicle Team';
          break;
        }
        //delete
        case 'Delete Vehicle Team': {
          if (this.vehicleTeamTableBoxSelectedRow.length === 0) {
            this.$showAlert('error', 'No vehicle team is selected', 'Please select a vehicle team to delete');
            break;
          }

          this.$fullscreenLoading('Getting Vehicle Team Details');
          this.populatePopupEntryFields(
            await this.getVehicleTeamDetails(this.vehicleTeamTableBoxSelectedRow[0]['Team']),
          );
          this.$fullscreenLoading();

          const promptMessage = `Are you sure you want to delete Vehicle Team <b>${this.vehicleTeamTableBoxSelectedRow[0]['Team']}</b>?`;
          const deleteConfirmation = await this.$showAlert('warning', 'Delete Vehicle Team', promptMessage, [
            { text: 'Delete', textColor: 'white', color: 'red' },
            { text: 'Cancel' },
          ]);

          if (deleteConfirmation == 'Cancel') {
            break;
          }

          this.$fullscreenLoading('Deleting Vehicle Team');
          const result = await this.$apiCallV2(
            '/VehicleTeam/SaveVehicleTeam',
            this.formatSaveVehicleTeamRequestBody('D'),
          );
          this.$fullscreenLoading();
          //Delete Error
          if (result[0]['Results'] != '0') {
            this.$showAlert(
              'error',
              'Vehicle Team NOT Deleted',
              `There was an error deleting Vehicle Team ${this.vehicleteamTableBoxSelectedRow[0]['Team']}`,
            );
            break;
          }
          //Delete Successful
          this.$showAlert(
            'success',
            'Vehicle Team Deleted',
            `Successfully deleted Vehicle Team ${this.vehicleTeamTableBoxSelectedRow[0]['Team']}`,
          );
          this.getVehicleTeamListMaster();
          this.vehicleTeamTableBoxSelectedRow = [];
          break;
        }

        case 'View Vehicle Team': {
          const selectedTeamCode = this.vehicleTeamTableBoxSelectedRow[0]?.Team;
          if (!selectedTeamCode) {
            this.$showAlert('error', 'No Vehicle Team is selected', 'Please select a Vehicle Team to view');
            return;
          }

          this.$fullscreenLoading('Getting Vehicle Team Details');
          this.populatePopupEntryFields(
            await this.getVehicleTeamDetails(this.vehicleTeamTableBoxSelectedRow[0]['Team']),
          );
          await this.getVehicleWithTeamListMaster(selectedTeamCode);
          this.$fullscreenLoading();
          this.popupEntryTitle = 'View Vehicle Team';
          this.viewMode = true;
          this.viewModePK = true;
          this.showPopupEntry = true;

          this.getVehicleWithOutTeamListMaster();
          break;
        }
      }
    },

    watchSystemSelection: async function (newSystem) {
      if (this.popupEntryTitle === 'New Vehicle Team' && newSystem) {
        const systemCode = newSystem['System']?.toUpperCase();
        if (systemCode === 'HMS' || systemCode === 'TMS') {
          this.vehicleWithTeam = [];
          this.vehicleWithoutTeamTableBoxSelectedRow = [];
          this.vehicleWithTeamTableBoxSelectedRow = [];
          this.$fullscreenLoading('Loading Vehicle Data');
          await this.getVehicleWithOutTeamListMaster();
          this.$fullscreenLoading();
        } else {
          this.vehicleWithTeam = [];
          this.vehicleWithoutTeam = [];
          this.showAddNewTeamInput = false;
        }
      }
    },

    //clear the messages in the popup entry
    clearPopupEntryMessages: function () {
      this.popupEntryRequiredError = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryMessages = [];
      this.popupEntryErrorMessages = [];
    },

    //reset the fields in the popup entry
    resetPopupEntryFields: function () {
      this.popupEntryTitle = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.teamCodeInputValue = '';
      this.teamCodeErr = '';
      this.teamDescription = '';
      this.teamDescriptionErr = '';
      this.selectedTeamGroup = null;
      this.teamGroupErr = '';
      this.systemErr = '';
      this.selectedSystem = null;
      this.vehicleWithTeam = [];
      this.vehicleWithoutTeam = [];
      this.vehicleWithoutTeamTableBoxSelectedRow = [];
      this.vehicleWithTeamTableBoxSelectedRow = [];
      this.showAddNewTeamInput = false;
      this.previousSystem = null;
      this.isUserSelection = false;
    },
    //populate the fields in the popup entry with the data from the selected vehicle team
    populatePopupEntryFields: function (vehicleTeamDetails) {
      this.isUserSelection = false;
      this.createdBy = `${vehicleTeamDetails['UserID']?.trim() ?? ''} ${vehicleTeamDetails['DateCreated'] ? new Date(vehicleTeamDetails['DateCreated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.updatedBy = `${vehicleTeamDetails['UserID']?.trim() ?? ''} ${vehicleTeamDetails['DateUpdated'] ? new Date(vehicleTeamDetails['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''}`;

      this.teamCodeInputValue = this.populateTextTrim(vehicleTeamDetails['TeamCode']);
      this.teamDescription = this.populateTextTrim(vehicleTeamDetails['TeamDescription']);
      this.selectedTeamGroup =
        vehicleTeamDetails['TeamGroup'] ?
          this.populateObject(this.teamGroupListMaster, 'Team', vehicleTeamDetails['TeamGroup'])
        : null;
      this.selectedSystem =
        vehicleTeamDetails['System'] ?
          this.populateObject(this.systemListMaster, 'System', vehicleTeamDetails['System'])
        : null;
    },

    //check if the fields are filled in correctly
    checkPopupEntryFields: function () {
      let error = false;

      this.clearPopupEntryMessages();
      if (this.teamCodeInputValue.trim() === '') {
        this.teamCodeErr = 'Team Code is required!';
        this.popupEntryRequiredError.push({ key: 'teamCodeErr', value: 'Team Code is required!' });
        error = true;
      } else if (this.teamCodeInputValue.length > 10) {
        //check with backend error handle
        this.teamCodeErr = 'Team Code cannot exceed 10 characters!';
        this.popupEntryRequiredError.push({ key: 'teamCodeErr', value: 'Team Code cannot exceed 10 characters!' });
        error = true;
      }

      if (this.teamDescription.trim() === '') {
        this.teamDescriptionErr = 'Description is requried!';
        this.popupEntryRequiredError.push({ key: 'teamDescriptionErr', value: 'Team Description is required!' });
        error = true;
      } else if (this.teamDescriptionErr.length > 100) {
        this.teamDescriptionErr = 'Team Description cannot exceed 100 characters!';
        this.popupEntryRequiredError.push({
          key: 'teamDescriptionErr',
          value: 'Team Description cannot exceed 100 characters!',
        });
        error = true;
      }

      if (!this.selectedSystem) {
        this.systemErr = 'System selection is required!';
        this.popupEntryRequiredError.push({ key: 'systemErr', value: 'System selection is required!' });
        error = true;
      }

      return error;
    },

    popupEntrySaveClicked: async function () {
      const isInvalid = this.checkPopupEntryFields();
      if (isInvalid) {
        return;
      }
      const action = this.popupEntryTitle[0];
      const requestBody = this.formatSaveVehicleTeamRequestBody(action);
      this.$fullscreenLoading('Saving Vehicle Team');
      const result = await this.$apiCallV2('/VehicleTeam/SaveVehicleTeam', requestBody);
      this.$fullscreenLoading();

      // Handle save result dynamically
      let parsedResult = result;
      if (typeof result === 'string') {
        try {
          parsedResult = JSON.parse(result);
        } catch (e) {
          this.popupEntryErrorMessages.push('Invalid response from save API.');
          return;
        }
      } else if (typeof result !== 'object' || result === null) {
        this.popupEntryErrorMessages.push('Unexpected response from save API.');
        return;
      }

      if (parsedResult[0]['Results'] !== '0') {
        this.popupEntryErrorMessages.push(`Error saving vehicle team: ${parsedResult[0]['ErrMsg'] || 'Unknown error'}`);
        return;
      }

      //save successful
      this.resetPopupEntryFields();
      this.viewMode = true;
      this.viewModePK = true;
      this.popupEntryTitle = 'View Vehicle Team';

      this.$fullscreenLoading('Refreshing Vehicle Team');
      await this.getVehicleTeamListMaster();
      const vehicleTeamDetails = await this.getVehicleTeamDetails(requestBody.teamcode);
      this.populatePopupEntryFields(vehicleTeamDetails);
      await this.getVehicleWithTeamListMaster(requestBody.teamcode);
      this.$fullscreenLoading();
      this.popupEntrySuccessMessages.push(
        action === 'N' ?
          `Successfully created Vehicle Team: ${this.teamCodeInputValue}`
        : `Successfully edited Vehicle Team: ${this.teamCodeInputValue}`,
      );
    },

    formatSaveVehicleTeamRequestBody: function (action) {
      const requestBody = {
        teamcode: this.teamCodeInputValue.trim(),
        teamdescription: this.teamDescription,
        teamgroup: this.selectedTeamGroup?.['Team'] || '',
        system: this.selectedSystem?.['System'],
        action: action,
        dateupdated: new Date().toISOString(),
      };
      if ((action === 'E' || action === 'A')&& this.vehicleWithoutTeamTableBoxSelectedRow.length > 0) {
        requestBody.vehicles = this.vehicleWithoutTeamTableBoxSelectedRow.map((vehicle) => ({
          vehiclecode: vehicle['Vehicle Code'] || vehicle.VehicleCode || vehicle.vehiclecode || '',
          lorryno: vehicle['Lorry No'] || vehicle.LorryNo || vehicle.lorryno || '',
          vehiclecategory: vehicle['Vehicle Category'] || vehicle.VehicleCategory || vehicle.vehiclecategory || '',
        }));
      }
      return requestBody;
    },

    checkVehicleAssignments: async function (teamCode, system, vehicles) {
      const requestBody = {
        team: teamCode,
        system: system,
        vehicles: vehicles.map((vehicle) => {
          const mappedVehicle = {
            vehiclecode: vehicle['Vehicle Code'] || vehicle.VehicleCode || vehicle.vehiclecode || '',
            lorryno: vehicle['Lorry No.'] || vehicle.LorryNo || vehicle.lorryno || '',
            vehiclecategory: vehicle['Vehicle Category'] || vehicle.VehicleCategory || vehicle.vehiclecategory || '',
          };
          return mappedVehicle;
        }),
      };
      try {
        const result = await this.$apiCallV2('/VehicleTeam/checkVehicleTeamManagement', requestBody);
        return result;
      } catch (error) {
        return null;
      }
    },

    addNewTeamInputClicked: async function (_pointerEvent) {
      const isInvalid = this.checkPopupEntryFields();
      if (isInvalid) return;
      const selectedVehicles = this.vehicleWithoutTeamTableBoxSelectedRow;
      if (selectedVehicles.length === 0) {
        this.popupEntryErrorMessages.push('No vehicles selected to add to the team.');
        return;
      }

      if (!this.viewModePK) {
        const teamSaveRequestBody = this.formatSaveVehicleTeamRequestBody('N');
        delete teamSaveRequestBody.vehicles;
        this.$fullscreenLoading('Saving New Vehicle Team');
        const teamSaveResult = await this.$apiCallV2('/VehicleTeam/SaveVehicleTeam', teamSaveRequestBody);
        this.$fullscreenLoading();

        let parsedTeamSaveResult = teamSaveResult;
        if (typeof teamSaveResult === 'string') {
          parsedTeamSaveResult = JSON.parse(teamSaveResult);
        }
        if (parsedTeamSaveResult[0]['Results'] !== '0') {
          this.popupEntryErrorMessages.push(
            `Error saving new vehicle team: ${parsedTeamSaveResult[0]['ErrMsg'] || 'Unknown error'}`,
          );
          return;
        }
        this.viewModePK = true;
        this.popupEntrySuccessMessages.push(`Successfully created Vehicle Team: ${this.teamCodeInputValue}`);
      }

      this.$fullscreenLoading('Validating Vehicle Assignments');
      const validationResult = await this.checkVehicleAssignments(
        this.teamCodeInputValue.trim(),
        this.selectedSystem?.['System'],
        selectedVehicles,
      );
      this.$fullscreenLoading();

      let parsedValidationResult = validationResult;
      if (typeof validationResult === 'string') {
        parsedValidationResult = JSON.parse(validationResult);
      }
      if (parsedValidationResult[0]['Results'] === '1') {
        this.popupEntryErrorMessages.push(parsedValidationResult[0]['ErrMsg']);
        return;
      } else if (parsedValidationResult[0]['Results'] === '2') {
        const confirmation = await this.$showAlert(
          'warning',
          'Vehicle Assignment Conflict',
          parsedValidationResult[0]['ErrMsg'],
          [
            { text: 'Yes', textColor: 'white', color: 'green' },
            { text: 'No', textColor: 'white', color: 'red' },
          ],
        );
        if (confirmation === 'No') return;
      }      

      const vehicleTeamRequest = this.formatSaveVehicleTeamRequestBody('E');
      this.$fullscreenLoading('Saving Vehicle Team');
      const vehicleTeamResult = await this.$apiCallV2('/VehicleTeam/SaveVehicleTeam', vehicleTeamRequest);
      //this saves the Team every time vehicle assignment is made
      //I think Vehicle Assignment is supposed to be another function or at least another Check
      //but this works for now

      //When action A, assign vehicles
      const vehicleAssignRequestBody = this.formatSaveVehicleTeamRequestBody('A');
      this.$fullscreenLoading('Assigning Vehicles to Team');
      const vehicleAssignResult = await this.$apiCallV2('/VehicleTeam/SaveVehicleTeam', vehicleAssignRequestBody);
      this.$fullscreenLoading();

      const {Results: teamResults, ErrMsg: teamMsg} = vehicleTeamResult[0] || {};

      let parsedVehicleAssignResult = vehicleAssignResult;
      if (typeof vehicleAssignResult === 'string') {
        parsedVehicleAssignResult = JSON.parse(vehicleAssignResult);
      }
      if (parsedVehicleAssignResult[0]['Results'] !== '0' || teamResults != '0') {
        this.popupEntryErrorMessages.push(
          `Error assigning vehicles: ${parsedVehicleAssignResult[0]['ErrMsg'] || 'Unknown error'}`,
        );
        this.popupEntryErrorMessages.push(`Error saving Team: ${teamMsg || 'Unknown error'}`);
        return;
      }
      this.vehicleWithoutTeamTableBoxSelectedRow = [];

      this.popupEntryTitle = 'View Vehicle Team';
      this.viewMode = true;
      this.viewModePK = true;

      this.$fullscreenLoading('Refreshing Vehicle Team');
      await this.getVehicleTeamListMaster();
      await this.getVehicleWithTeamListMaster(this.teamCodeInputValue.trim());
      await this.getVehicleWithOutTeamListMaster(this.teamCodeInputValue.trim());
      this.populatePopupEntryFields(await this.getVehicleTeamDetails(this.teamCodeInputValue.trim()));
      //this technically counts as a field save, so another refetch is done here
      this.$fullscreenLoading();
      this.popupEntrySuccessMessages.push(`Successfully added vehicles to team: ${this.teamCodeInputValue}`);
    },

    removeVehiclesClicked: async function () {
      if (!this.isHmsOrTms) {
        this.$showAlert('warning', 'System Restriction', 'Vehicle management is only available for HMS or TMS systems');
        return;
      }

      const selectedVehicles = this.vehicleWithTeamTableBoxSelectedRow;
      if (selectedVehicles.length === 0) {
        this.popupEntryErrorMessages.push('No vehicles selected to remove from the team.');
        return;
      }

      const confirmation = await this.$showAlert(
        'warning',
        'Confirm Vehicle Removal',
        `Are you sure you want to remove ${selectedVehicles.length} vehicle(s) from team '${this.teamCodeInputValue}'?`,
        [
          { text: 'Yes', textColor: 'white', color: 'green' },
          { text: 'No', textColor: 'white', color: 'red' },
        ],
      );
      if (confirmation === 'No') return;

      const requestBody = {
        teamcode: this.teamCodeInputValue.trim(),
        teamdescription: this.teamDescription,
        teamgroup: this.selectedTeamGroup?.['Team'] || '',
        system: this.selectedSystem?.['System'],
        action: 'R',
        vehicles: selectedVehicles.map((vehicle) => ({
          vehiclecode: vehicle['Vehicle Code'] || vehicle.VehicleCode || vehicle.vehiclecode || '',
          lorryno: vehicle['Lorry No'] || vehicle.LorryNo || vehicle.lorryno || '',
          vehiclecategory: vehicle['Vehicle Category'] || vehicle.VehicleCategory || vehicle.vehiclecategory || '',
        })),
      };

      this.$fullscreenLoading('Removing Vehicles from Team');
      const result = await this.$apiCallV2('/VehicleTeam/SaveVehicleTeam', requestBody);
      this.$fullscreenLoading();

      let parsedResult = result;
      if (typeof result === 'string') {
        parsedResult = JSON.parse(result);
      }
      if (parsedResult[0]['Results'] !== '0') {
        this.popupEntryErrorMessages.push(`Error removing vehicles: ${parsedResult[0]['ErrMsg'] || 'Unknown error'}`);
        return;
      }

      this.viewMode = true;
      this.popupEntryTitle = 'View Vehicle Team';

      this.$fullscreenLoading('Refreshing Vehicle Team');
      await this.getVehicleWithTeamListMaster(this.teamCodeInputValue.trim());
      await this.getVehicleWithOutTeamListMaster(this.teamCodeInputValue.trim());
      this.vehicleWithTeamTableBoxSelectedRow = [];
      this.$fullscreenLoading();

      this.popupEntrySuccessMessages.push(`Successfully removed vehicles from team: ${this.teamCodeInputValue}`);
    },

    popupEntryRequiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    populateTextTrim: function (text) {
      return text ? text.trim() : '';
    },
    populateObject: function (data, key, compare) {
      try {
        return data.find((d) => (d[key]?.trim?.() ?? d[key]) == (compare?.trim?.() ?? compare));
      } catch (error) {
        return null;
      }
    },
    handleSystemSelection(newSystem) {
      this.isUserSelection = true;
      this.selectedSystem = newSystem;
    },
  },

  mounted() {
    //pageSASControlAccess is an event that is triggered when the user's access control is loaded
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Vehicle Team') {
        x.data.forEach((k) => {
          const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          } else {
            const selectedTab = this.tabItems.find((t) => t['key'] == k['Control']);
            if (selectedTab) {
              selectedTab['disabled'] = k['PropertiesValue'] != 'True';
            }
          }
        });
      }
    });

    const mountedPromises = [];
    let promisesFulfilled = 0;

    mountedPromises.push(
      this.getVehicleTeamListMaster().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
      this.getTeamGroupListMaster().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SYSTEM' }).then((result) => {
        this.systemListMaster = result.map((item) => ({
          ...item,
          combinedSystemName: `${item['System']} - ${item['Application Name']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    //Promise.allSettled is used to wait for all promises to be resolved or rejected, wait all task finish
    Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });
  },
  watch: {
    selectedSystem: {
      handler(newSystem, oldSystem) {
        if (oldSystem !== newSystem) {
          this.previousSystem = oldSystem;
        }
        if (!newSystem) return;

        const systemCode = newSystem['System']?.toUpperCase();
        if (systemCode === 'HMS' || systemCode === 'TMS') {
          if (this.isUserSelection) {
            this.$showAlert(
              'warning',
              'Confirm System Selection',
              `Are you sure you want to select <b>${systemCode}</b>? Once selected, you cannot change the system.`,
              [
                { text: 'Yes', textColor: 'white', color: 'green' },
                { text: 'No', textColor: 'white', color: 'red' },
              ],
            ).then((response) => {
              if (response === 'No') {
                this.selectedSystem = this.previousSystem;
              } else {
                this.watchSystemSelection(newSystem);
              }
              this.isUserSelection = false;
            });
          } else {
            this.watchSystemSelection(newSystem);
          }
        } else {
          this.watchSystemSelection(newSystem);
          this.isUserSelection = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.vehicle-team-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;

  > .table-box-container {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }
  .team-code {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .team-code-input {
    flex: 1;
  }

  .query-button {
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;
  }

  .team-management-section {
    display: flex;
    flex-direction: row;
    overflow-y: scroll;
    width: 100%;
    overflow-x: hidden;
    margin-top: 5px;
    height: 100%;

    .call-to-action-buttons {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin: 5px;

      > button:nth-child(1) {
        margin-right: 5px;
      }
    }

    .table-box-container {
      height: calc(100% - 40px);
      width: 100%;
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      display: flex;
      overflow: hidden;
    }

    .vehicle-list {
      width: 100%;
    }

    .vehicles-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 75%;
      margin-left: 3px;
    }
  }
}
</style>
